var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-top"},[_c('Icon',{staticClass:"icon-class",attrs:{"type":"ios-arrow-back","size":"26"},on:{"click":_vm.routerBack}}),_c('span',{on:{"click":_vm.reload}},[_vm._v(_vm._s(_vm.title))]),_vm._t("btn")],2)}
var staticRenderFns = []

export { render, staticRenderFns }